// extracted by mini-css-extract-plugin
module.exports = {"form":"import-welcome_form__Y1lky","logoContainer":"import-welcome_logoContainer__3E7UU","inputContainerGroup":"import-welcome_inputContainerGroup__3EsaK"};